import { useEffect, useState } from 'react';
import { API } from '../api';
import DestinoCard from '../components/DestinoCard';
import { Link } from 'react-router-dom';
import { FaHeadset, FaShieldAlt, FaStar, FaClock, FaMapMarkedAlt, FaUserTie, FaRoute, FaCamera } from 'react-icons/fa';
import logo2 from '../assets/logo2.jpeg';
import logo3 from '../assets/logo3.jpeg';
import logo4 from '../assets/logo4.jpg';
import heroVideo from "../assets/portada.mp4";
import './Home.css';

function Home() {
  const [empresa, setEmpresa] = useState(null);
  const [destinos, setDestinos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 👉 CARGA DE DATOS
  useEffect(() => {
     window.scrollTo(0,0);
    const fetchData = async () => {
      try {
        const empresaRes = await API.get('empresa/');
        if (empresaRes.data.length > 0) setEmpresa(empresaRes.data[0]);

        const destinosRes = await API.get('destinos/destacados/');
        setDestinos(destinosRes.data);

      } catch (err) {
        console.error(err);
        setError('No se pudieron cargar los datos');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <p style={{ textAlign: 'center', marginTop: '50px' }}>Cargando...</p>;
  if (error) return <p style={{ textAlign: 'center', marginTop: '50px' }}>{error}</p>;
  if (!empresa) return <p style={{ textAlign: 'center', marginTop: '50px' }}>No hay datos de la empresa</p>;

  return (
    <>
 {/*HERO PORTADA VIDEO */}
<div className="home-container hero-cinematic">

  <section className="hero-slide video-hero">

    {/*IDEO DE FONDO */}
    <video
      className="hero-video"
      autoPlay
      muted
      loop
      playsInline
    >
      <source src={heroVideo} type="video/mp4" />
    </video>

    {/* Overlay */}
    <div className="hero-overlay"></div>

    {/* Contenido */}
    <div className="hero-content">
      <span className="hero-tag">EXPLORA</span>

      <h1>{empresa.nombre}</h1>

      <p>{empresa.slogan}</p>

      <div className="hero-actions">
        <Link to="/destinos" className="btn-hero primary">
          Ver destinos
        </Link>

        <Link to="/contacto" className="btn-hero secondary">
          Contáctanos
        </Link>
      </div>
    </div>

  </section>

</div>

      {/* DESTINOS POPULARES */}
      <section className="destinos-populares">
       <h2 className="section-title">DESTINOS POPULARES</h2>
        <div className="destinos-list">
          {destinos.length > 0 ? (
            destinos.map(d => <DestinoCard key={d.id} destino={d} />)
          ) : (
            <p>No hay destinos disponibles</p>
          )}
        </div>
      </section>

      {/* POR QUÉ ELEGIRNOS */}
      <section className="porque-elegirnos">
        <h2 className="section-title">¿POR QUÉ ELEGIRNOS?</h2>

        <div className="beneficios">
          <div className="beneficio-card">
            <FaHeadset className="beneficio-icono" />
            <h3>Atención Personalizada</h3>
            <p>Te acompañamos desde el primer contacto hasta el final de tu viaje,
               resolviendo tus dudas, ajustando itinerarios y brindándote
                una atención cercana y humana para que solo te preocupes por disfrutar</p>
          </div>

          <div className="beneficio-card">
            <FaShieldAlt className="beneficio-icono" />
            <h3>Tours Seguros</h3>
            <p>Trabajamos únicamente con operadores certificados, 
              transporte autorizado y protocolos de seguridad que garantizan tranquilidad
               en cada experiencia, cuidando siempre tu bienestar y el de tu familia.</p>
          </div>

          <div className="beneficio-card">
            <FaStar className="beneficio-icono" />
            <h3>Experiencias Únicas</h3>
            <p>Diseñamos experiencias auténticas que conectan cultura, naturaleza y aventura,
               creando recuerdos inolvidables adaptados a tu estilo de viaje, intereses y ritmo.</p>
          </div>

          <div className="beneficio-card">
            <FaClock className="beneficio-icono" />
            <h3>Soporte 24/7</h3>
            <p>Nuestro equipo está disponible las 24 horas para asistirte ante cualquier imprevisto, 
              cambios de itinerario o consultas durante tu viaje, asegurando 
              una experiencia sin preocupaciones.</p>
          </div>
        </div>
      </section>

      {/* SERVICIOS */}
      <section className="servicios">
        <h2 className="section-title">NUESTROS SERVICIOS</h2>
        <p className="servicios-subtitle">
          Creamos experiencias únicas para que disfrutes cada destino al máximo.
        </p>

        <div className="servicios-grid">
          <div className="servicio-card">
            <FaMapMarkedAlt className="servicio-icono" />
            <h3>Paquetes Turísticos</h3>
            <p>Ofrecemos paquetes completos a los destinos más fascinantes del Perú.</p>
            <button>Ver más</button>
          </div>

          <div className="servicio-card">
            <FaUserTie className="servicio-icono" />
            <h3>Guías Expertos</h3>
            <p>Nuestros guías locales te brindan experiencias culturales inolvidables.</p>
            <button>Ver más</button>
          </div>

          <div className="servicio-card">
            <FaRoute className="servicio-icono" />
            <h3>Tours Personalizados</h3>
            <p>Diseñamos itinerarios a medida según tus preferencias y necesidades.</p>
            <button>Ver más</button>
          </div>

          <div className="servicio-card">
            <FaCamera className="servicio-icono" />
            <h3>Fotos Profesionales</h3>
            <p>
              Capturamos tus mejores momentos de viaje con fotógrafos profesionales,
              para que conserves recuerdos inolvidables.
            </p>
            <button>Ver más</button>
          </div>
        </div>
      </section>

{/* TESTIMONIOS */}
<section className="testimonios">
  <h2 className="section-title">TESTIMONIOS</h2>

  <div className="testimonios-grid">
    <div className="testimonio">
      <img
        src="/cliente3.jpg"
        alt="Cliente feliz"
        className="testimonio-img"
      />
      <p className="testimonio-texto">
        “Una experiencia increíble. Todo estuvo perfectamente organizado
        y el trato fue excelente. ¡Recomendado!”
      </p>
      <span className="testimonio-nombre">— Isabela Martinez</span>
    </div>

    <div className="testimonio">
      <img
        src="/cliente4.jpg"
        alt="Cliente satisfecho"
        className="testimonio-img"
      />
      <p className="testimonio-texto">
        “Viajar con esta agencia fue lo mejor. Los destinos fueron hermosos
        y la atención impecable. Volveré a reservar.”
      </p>
      <span className="testimonio-nombre">— Carlos Perez</span>
    </div>
  </div>
</section>

{/* CTA FINAL */}
<section className="cta">
  <div className="cta-content">
    <h2>¿Listo para tu próxima aventura?</h2>
    <p>
      Descubre los mejores destinos y vive una experiencia inolvidable con nosotros.
    </p>

    <Link to="/destinos">
      <button className="cta-btn">
        Explorar Destinos
      </button>
    </Link>
  </div>
</section>

<section className="logotipos">
  <div className="logotipos-content">

<img src={logo2} alt='logo2' className='logotipos-img'/>
<img src={logo3} alt='logo3' className='logotipos-img'/>
<img src={logo4} alt='logo4' className='logotipos-img'/>

  </div>
</section>
    </>
  );
}

export default Home;
